import useCreateUserLink from "../../../hooks/useCreateUserLink";
import CreateUserLinkListView from "./CreateUserLinkListView/CreateUserLinkListView";
import useSingleCreateUserLink from "../../../hooks/useSingleCreateUserLink";
import SingleCreateUserLinkModal from "../../SingleCreateUserLink/SingleCreateUserLinkInfoModal/SingleCreateUserLinkModal";
import SingleOrganization from "../../../../organization/components/SingleOrganization";
import Pagination from "../../../../../common/components/organisme/Pagination/Pagination";
import { LoaderSreen } from "../../../../../common/components/molecule/Loader/Loader";
import ErrorScreenApp from "../../../../errorHandler/components/ErrorScreenApp/ErrorScreenApp";
import { OrderByType } from "../../../../../utils/genericAPI/useGenericAPI";
import { CreateUserLink } from "../../../types/createUserLink.type";
import { ButtonWithComfirmationModal } from "../../../../../common/components/organisme/ModalWindow/ModalWindow";
import useNavigationApp from "../../../../../navigation/useNavigationApp";
import { useAuth } from "../../../../auth/hooks";
import { userRoles } from "../../../../user/types/user.types";

/**
 * CreateUserLinkListPresenter
 * @param param0
 * @returns
 */
export default function CreateUserLinkListPresenter({
  organizationId,
  pageSize,
  orderBy,
}: {
  organizationId?: string;
  pageSize?: number;
  orderBy?: OrderByType<CreateUserLink>;
}) {
  const {
    allCreateUserLinksQuery: { isLoading, error, data, setPage },
  } = useCreateUserLink({ organizationId, pageSize, orderBy });

  const navigationApp = useNavigationApp();
  if (isLoading) {
    return <LoaderSreen heigth="200px" />;
  }
  if (error) {
    return <ErrorScreenApp axiosError={error} />;
  }

  const modaleId = "single-culk-modal";
  const contentConverted = data?.data?.map((item) => {
    const onClick = () => {
      navigationApp.goToSingleUserInvitationLink(item.uct_id, {
        keepURL: true,
      });
    };
    return {
      id: item.uct_id,
      fristnameUser: item.uct_firstname,
      lastnameUser: item.uct_lastname,
      expiresIn: item.uct_expired_at,
      status: item.uct_status,
      userRole: item.uct_user_role,
      emailUser: item.uct_email,
      actionBtnRender: () => <ActionTokenBtn id={item.uct_id} />,
      onClick: () => {
        onClick();
      },
      organizationNameRender: () => (
        <SingleOrganization.Name
          organizationId={item.uct_organization_id}
          nbchar={13}
        />
      ),
    };
  });

  const pagination = data?.pagination;
  return (
    <>
      <CreateUserLinkListView
        content={contentConverted}
        nbFound={data?.pagination.total_count}
      />
      <Pagination
        centered
        currentPage={pagination?.current_page}
        setCurrentPage={setPage}
        nbBtnToDisplay={5}
        lastPage={pagination?.total_pages}
      />
      <SingleCreateUserLinkModal modaleId={modaleId} />
    </>
  );
}

const ActionTokenBtn = ({ id }: { id: string }) => {
  const {
    deleteSingleCreateUserLink: deleteQ,
    singleCreateUserLinkQuery: { data },
  } = useSingleCreateUserLink(id);
  const { userRole } = useAuth();
  if (!userRole || userRole < userRoles.ADMIN) {
    return <></>;
  }
  return (
    <div style={{ display: "flex", justifyContent: "flex-end" }}>
      <ButtonWithComfirmationModal
        titleModal="Suppression"
        desc={
          "Voulez-vous vraiment supprimer l'invitation pour " +
          data?.uct_email +
          "?"
        }
        height={"10px"}
        fontSize={"0.8rem"}
        borderRaduis={"10px"}
        variant={"outlined"}
        isLoading={deleteQ.isLoading}
        onClick={() => {
          deleteQ.mutate({});
        }}
        label="Supprimer"
        borderColor="#7C030370"
        fontColorHex="#7C030370"
        bgColorHex="transparent"
      />
    </div>
  );
};
